import React from 'react';
import FsgoItem from './FsgoItem';
import FsgoVideosService from '../FsgoVideosService';

class FsgoItems extends React.Component {
	constructor(props) {
		super(props);
	}

	isSeparatorShown() {
		const isLive = this.props.state === 'live';

		if (this.props.isFifaWC) return isLive;

		return FsgoVideosService.isViewAllSeparatorShown(this.props.regionNames, isLive);
	}

	render() {
		const title = this.props.title;
		const state = this.props.state;
		const isLive = state === 'live';
		const videos = this.props.items;
		const allCount = this.props.allCount;
		const regionNames = this.props.regionNames;
		const isFifaWC = this.props.isFifaWC;
		const isMatches = this.props.isMatches;
		const isSeparatorShown = this.isSeparatorShown();
		const isViewAllShown = !this.props.isSE && ((isFifaWC && isLive) || !isLive || (videos.length !== allCount));
		let fifaWcClass = isFifaWC ? 'fifa-wc' : '';

		if (this.props.isFifaWCMatchesShown) fifaWcClass += ' fifa-wc-matches-shown';

		let idx = 1;
		let itemKey = 1;
		let regionKey = 1;

		return (
			<li className="tune-in-item">
				<div className="tune-in-item-container">
					<div className={state}>
						{(!isFifaWC || isLive || isMatches) &&
							<div className={`title ${fifaWcClass}`}>
								<div className={!isSeparatorShown ? 'text-block' : ''}>
									<span className={isSeparatorShown && regionNames.length > 0 ? 'title-block' : ''}>{title}</span>
									{regionNames.map(n => <span className="region-name" key={regionKey++}>{n}</span>)}
									{isSeparatorShown && isViewAllShown &&
										<span className="view-all-separator"></span>
									}
									{isViewAllShown &&
										<a className={`view-all ${state} ${fifaWcClass}`}
										   target="_blank"
										   href={isLive ? 'https://www.foxsports.com/tv-schedule' : 'https://www.foxsports.com/events-schedule'}>
											{isLive && !isFifaWC ? `View All (${allCount})` : 'Full Listings'}
										</a>
									}
								</div>
							</div>
						}
						{videos.length > 0 &&
                            <div className={`content ${fifaWcClass} ${isMatches ? 'matches' : ''}`}>
                                <ul className="videos">
                                    {videos.map((v) => {
                                        return (
                                            <FsgoItem item={v}
                                                      state={state}
                                                      isPost={this.props.isPost}
                                                      postType={this.props.postType}
													  isLoggedIn={this.props.isLoggedIn}
                                                      isFifaWC={isFifaWC}
                                                      isWatchReplay={this.props.isWatchReplay}
                                                      key={itemKey++}
                                                      idx={idx++} />
                                        );
                                    })}
                                </ul>
                            </div>
						}
					</div>
				</div>
			</li>
		)
	}
}

export default FsgoItems;
